import type { RecentTasks } from '~/types/task.type'
import { useStorage } from '@vueuse/core'

export default function useRecentTasks() {
  const storage = useStorage<RecentTasks>('recent-tasks', {
    expanded: false,
    tasks: [],
  })

  return storage
}
